export default __webpack_public_path__ + "mejs-controls-86914add7bebe1278aaba56251e04474.svg";